<template>
	<v-list density="compact">
		<v-list-item class="list-ChartContextMenu" v-for="(item, index) in itemsForTrenchEdit" :key="index"
			@click="onCMClickForTrenchEdit($event, item.id)">
			<v-list-item-title>
				{{ $t(item.title) }}
			</v-list-item-title>
		</v-list-item>
	</v-list>
</template>

<script lang="ts">
import { useStore, mapActions } from "vuex";
import { ObjectType } from "@/models/objects/types";

export default {
	setup() {
		const store = useStore();
		return { store };
	},
	props: {
		pathId: String,
		pointId: String,
		showRemoveOption: Boolean,
	},
	data: function () {
		return {
			itemsForTrenchEdit: [
				{ id: 2, title: "ADD" },
				...(this.showRemoveOption ? [{ id: 3, title: "Remove" }] : []),
				{ id: 5, title: "Update" },
				{ id: 7, title: "Undo" },
				{ id: 8, title: "Redo" },
			],
		};
	},
	watch: {
		showRemoveOption: function (showRemoveOption) {
			this.itemsForTrenchEdit = [
				{ id: 2, title: "ADD" },
				{ id: 3, title: "Remove" },
				{ id: 5, title: "Update" },
				{ id: 7, title: "Undo" },
				{ id: 8, title: "Redo" },
			];

			if (!showRemoveOption) {
				const itemIndex = this.itemsForTrenchEdit.findIndex(
					(item) => item.id === 3,
				);
				if (itemIndex > -1) {
					this.itemsForTrenchEdit.splice(itemIndex, 1);
				}
			}
		},
	},
	methods: {
		...mapActions("object", ["endEdit"]),

		onCMClickForTrenchEdit(e, id) {
			e.preventDefault();
			const numberOfPathPoints = this.store.getters.viewer.getTrenchPointLength(
				this.pathId,
			);
			const clickedIndex = this.store.getters.viewer.getControlPointIndexById(
				this.pathId,
				this.pointId,
			);
			switch (id) {
				case 2:
					this.store.getters.viewer.addControlPointOnTrench(
						this.pathId,
						this.pointId,
					);
					break;
				case 3:
					this.store.getters.viewer.removeControlPointOnTrench(this.pointId);
					break;
				case 5:
					window.dispatchEvent(
						new CustomEvent("openPropertyDialog", {
							detail: {
								id: this.pathId,
								type: 3,
								pointId: this.pointId,
								entityUnderEdit: ObjectType.TRENCH,
								disabilityConditions: "Z",
								origin: "CesiumView",
							},
						}),
					);
					break;
				case 7:
					this.store.getters.viewer.undo();
					break;
				case 8:
					this.store.getters.viewer.redo();
					break;
				case 9:
					//openup dialog box
					console.log("clicked point", {
						id: this.pathId,
						type: 5,
						clickedPointIndex: this.pointId,
						totalPoints: numberOfPathPoints,
					});
					window.dispatchEvent(
						new CustomEvent("openPropertyDialog", {
							detail: {
								id: this.pathId,
								type: 5,
								clickedPointIndex: clickedIndex,
								totalPoints: numberOfPathPoints,
							},
						}),
					);
					break;
			}
		},
	},
};
</script>

<style lang="scss" scoped>
.list-ChartContextMenu:hover {
	background-color: #0064ba !important;
}
</style>
